import { render, staticRenderFns } from "./UserSkeleton.vue?vue&type=template&id=5c99efb8&scoped=true"
import script from "./UserSkeleton.vue?vue&type=script&lang=js"
export * from "./UserSkeleton.vue?vue&type=script&lang=js"
import style0 from "./UserSkeleton.vue?vue&type=style&index=0&id=5c99efb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c99efb8",
  null
  
)

export default component.exports